import { memo } from 'react';
import t from 'common/i18n';
import RadioGroup from 'root/components/RadioGroup';
import Checkbox from 'root/components/Checkbox/Checkbox';

const NUMBER_OF_PEOPLE_OPTIONS = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
];

const NumberOfPeople = (props) => (
  <section className={props.className}>
    <label>{t('shutterstock.filters.people.label')}</label>
    <div className="flex items-center checkbox-wrapper mb4">
      <Checkbox
        className="flex-shrink-0 pointer"
        checked={props.withPeopleOnly}
        borderWidth={2}
        borderRadius={2}
        size={16}
        activeThemeColor="link"
        onClick={() => props.onChange({ withPeopleOnly: !props.withPeopleOnly })}
      />
      <div className="ml-3">{t(`shutterstock.filters.people.only_${props.mediaType}_with_people`)}</div>
    </div>
    <RadioGroup
      options={NUMBER_OF_PEOPLE_OPTIONS}
      disabled={!props.withPeopleOnly}
      showAsBoxes
      onChange={(newValue) => props.onChange({ numberOfPeople: newValue })}
      className="flex-shrink-0"
      value={props.value}
    />
  </section>
);

export default memo(NumberOfPeople);
